module.exports = __webpack_public_path__ + "img/gc_clair_1719.47a6975c.jpg";